export enum DMN_OPCAO_TRIBUTACAO {
  PROGRESSIVA = 1,
  ALIQUOTA_15 = 2,
  REGRESSIVA = 3
}